import script from "./BaseImagePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseImagePreview.vue?vue&type=script&setup=true&lang=ts"

import "./BaseImagePreview.vue?vue&type=style&index=0&id=50a44b4a&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a44b4a"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
